module.exports = __webpack_public_path__ + "img/position-rejected.a4bfff32.svg";